module.exports = __webpack_public_path__ + "static/media/study220324.9f126b73.jpg";